import {Action} from "redux";
import {SessionActions} from "./session.actions";
import {DepotActions} from "./depot.actions";

export interface IPayloadAction extends Action {
  payload?: any;
}

export const ACTION_PROVIDERS = [SessionActions, DepotActions];
export {SessionActions, DepotActions};



// WEBPACK FOOTER //
// ./src/app/shared/actions/index.ts